import React from "react";
import FormFieldTwoColumns from "./Layouts/FormFieldTwoColumns";
import FormText from "./FormText";
import { Translation } from "../TranslationWrapper/TranslationWrapper";
import { ControllerProps } from "react-hook-form";
import { FormProps } from "./FormProps";
import { TextFieldProps } from "@mui/material";

function FormTextTC(
  props: FormProps & Translation & { rules?: ControllerProps["rules"] } & { fieldProps?: TextFieldProps }
) {
  return (
    <FormFieldTwoColumns {...props}>
      <FormText name={props.name} />
    </FormFieldTwoColumns>
  );
}

export default FormTextTC;
